import { isFlagOn } from '@/flags';

/**
 * Freemium Source accounts are gated by the `source-freemium` LaunchDarkly
 * flag on whoami. Paid accounts keep `sourcing-dashboard-user-access` and
 * are not restricted here.
 */
export function isSourceFreemium(
  whoami:
    | { feature_flags?: Record<string, boolean | undefined> }
    | null
    | undefined,
): boolean {
  return isFlagOn(whoami, 'source-freemium');
}

/**
 * The select-openings step is skipped when openings were already chosen
 * (dashboard, Hire deep link, persisted storage) — except freemium users
 * with more than one opening, who must stay on the step so the restriction
 * dialog can fire.
 */
export function shouldSkipSelectOpeningsStep(
  openingCount: number,
  isFreemium: boolean,
): boolean {
  if (openingCount === 0) return false;
  if (isFreemium && openingCount > 1) return false;
  return true;
}
